/**
 * Sidebar navigation config — extracted from Layout.js for testability and
 * to keep the layout component under 300 lines. Each group is a section in
 * the sidebar. `hidden: true` items are filtered out at render time.
 */
import {
  LayoutDashboard, Sparkles, Package, Activity, Calculator, FileOutput,
  ShoppingCart, Cable, Building2, Cog, Users, Database, BarChart3, Mail,
  Inbox, HardDrive, ClipboardList, FileSpreadsheet, Settings, BriefcaseBusiness, ClipboardCheck,
  CalendarClock,
} from 'lucide-react';

export const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard, roles: ['user', 'manager', 'admin'] },
  { name: 'Inquiries', href: '/inquiries', icon: Inbox, roles: ['user', 'manager', 'admin'] },
  { name: 'My Follow-ups', href: '/followups', icon: CalendarClock, roles: ['user', 'manager', 'admin'] },
  { name: 'Document Import', href: '/document-processing', icon: Sparkles, roles: ['user', 'manager', 'admin'] },
];

export const partWorkflow = [
  { name: 'Parts Master', href: '/parts', icon: Package },
  { name: 'Process Flows', href: '/process-flows', icon: Activity },
  { name: 'Costings', href: '/costings', icon: Calculator },
];

export const salesNav = [
  { name: 'Quotations', href: '/quotations', icon: FileOutput },
  { name: 'Sales Orders', href: '/orders', icon: ShoppingCart },
  { name: 'Order Reviews', href: '/order-reviews', icon: ClipboardCheck },
];

export const wireNav = [
  { name: 'Wire Parts', href: '/wire/parts', icon: Cable },
  { name: 'Wire Costings', href: '/wire/costings', icon: Calculator },
  { name: 'Wire Quotations', href: '/wire/quotations', icon: FileOutput },
];

// Production Planning — disabled Feb 2026 (marketing-led pivot). Routes still in
// place to allow flipping it back on by adding entries here.
export const productionNav = [];

export const engineeringNav = [
  { name: 'Washer Calculator', href: '/engineering/washer-calculator', icon: Calculator },
];

export const masterData = [
  { name: 'Customers', href: '/customers', icon: Building2 },
  { name: 'Vendors', href: '/vendors', icon: BriefcaseBusiness },
  { name: 'Machines', href: '/machines', icon: Cog, hidden: true },
];

export const adminNav = [
  { name: 'Users', href: '/users', icon: Users },
  { name: 'Master Data', href: '/master-data', icon: Database },
  { name: 'Material Master', href: '/admin/material-master', icon: Package },
  { name: 'Activity Logs', href: '/admin/activity-logs', icon: Activity },
  { name: 'User Analytics', href: '/admin/user-analytics', icon: BarChart3 },
  { name: 'Email Settings', href: '/admin/email-settings', icon: Mail },
  { name: 'Email Inbox', href: '/admin/email-inbox', icon: Inbox },
  { name: 'Data Backups', href: '/admin/data-backups', icon: HardDrive },
  { name: 'Audit Logs', href: '/audit-logs', icon: ClipboardList },
  { name: 'Data Exports', href: '/exports', icon: FileSpreadsheet },
  { name: 'Settings', href: '/settings', icon: Settings },
];
